import React from 'react';
import { cn } from '../cn';
import { accentStyle } from './accents';
import { DASHBOARD_PERIODS } from './periods';
/** Today / This week / This month segmented control (V2 period standard). */
export const PeriodPicker = ({ value, onChange, disabled, accent = 'orange', className, }) => {
    const a = accentStyle(accent);
    return (React.createElement("div", { className: cn('inline-flex rounded-xl border p-1', a.segmentContainer, className) }, DASHBOARD_PERIODS.map((preset) => (React.createElement("button", { key: preset.value, type: "button", disabled: disabled, onClick: () => onChange(preset.value), className: cn('rounded-lg px-3 py-1.5 text-sm font-medium transition-colors disabled:opacity-60', value === preset.value ? a.segmentActive : a.segmentInactive) }, preset.label)))));
};
export default PeriodPicker;
